module.exports = __webpack_public_path__ + "static/img/oac_logo.e3fbaf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oac_logo.png
// module id = 306
// module chunks = 8